import i18n from "i18next";

export const getOptList = () => {
  return {
    prodActOptions: [
      { name: "Accesorios", val: "Accesorios" },
      { name: "Alimentos y bebidas", val: "Alimentos y bebidas" },
      { name: "Áreas comunes", val: "Áreas comunes" },
      { name: "Automóviles", val: "Automóviles" },
      { name: "Belleza y cuidado personal", val: "Belleza y cuidado personal" },
      { name: "Bodegas", val: "Bodegas" },
      { name: "Cajas de compensación", val: "Cajas de compensación" },
      { name: "Calzado y vestuario", val: "Calzado y vestuario" },
      { name: "Casinos", val: "Casinos" },
      { name: "Cine", val: "Cine" },
      { name: "Clínicas y centros de salud", val: "Clínicas y centros de salud" },
      { name: "Computación y electrónica", val: "Computación y electrónica" },
      { name: "Deporte y outdoor", val: "Deporte y outdoor" },
      { name: "Educación", val: "Educación" },
      { name: "Entretenimiento familiar", val: "Entretenimiento familiar" },
      { name: "Entretenimiento adulto (discotecas y pubs)", val: "Entretenimiento adulto (discotecas y pubs)" },
      { name: "Farmacia", val: "Farmacia" },
      { name: "Food court", val: "Food court" },
      { name: "Gimnasios", val: "Gimnasios" },
      { name: "Hipódromos", val: "Hipódromos" },
      { name: "Hogar y decoración", val: "Hogar y decoración" },
      { name: "Hotel", val: "Hotel" },
      { name: "Inmobiliarias y constructoras", val: "Inmobiliarias y constructoras" },
      { name: "Joyería y relojería", val: "Joyería y relojería" },
      { name: "Juegos de azar / casa de cambio", val: "Juegos de azar / casa de cambio" },
      { name: "Maletería", val: "Maletería" },
      { name: "Mejoramiento del hogar", val: "Mejoramiento del hogar" },
      { name: "Oficinas", val: "Oficinas" },
      { name: "Organizaciones de caridad benéficas o sin ánimos de lucro", val: "Organizaciones de caridad benéficas o sin ánimos de lucro" },
      { name: "Otros comidas", val: "Otros comidas" },
      { name: "Otros retail", val: "Otros retail" },
      { name: "Publicidad", val: "Publicidad" },
      { name: "Restaurantes", val: "Restaurantes" },
      { name: "Servicios", val: "Servicios" },
      { name: "Servicios financieros y bancos", val: "Servicios financieros y bancos" },
      { name: "Supermercado", val: "Supermercado" },
      { name: "Telecomunicaciones", val: "Telecomunicaciones" },
      { name: "Terminal de buses", val: "Terminal de buses" },
      { name: "Tienda departamental", val: "Tienda departamental" },
      { name: "Usuarios de zonas francas", val: "Usuarios de zonas francas" }
    ],

    parentesco: [
      { val: "Mi Persona", text: i18n.t("forms.options.miPersona", { ns: "forms" }) },
      { val: "Cónyuge", text: i18n.t("forms.options.conyuge", { ns: "forms" }) },
      { val: "Conviviente", text: i18n.t("forms.options.conviviente", { ns: "forms" }) },
      { val: "Padre", text: i18n.t("forms.options.padre", { ns: "forms" }) },
      { val: "Madre", text: i18n.t("forms.options.madre", { ns: "forms" }) },
      { val: "Hijo(a)", text: i18n.t("forms.options.hijo", { ns: "forms" }) },
      { val: "Hermano(a)", text: i18n.t("forms.options.hermano", { ns: "forms" }) },
      { val: "Abuelo(a)", text: i18n.t("forms.options.abuelo", { ns: "forms" }) },
      { val: "Nieto(a)", text: i18n.t("forms.options.nieto", { ns: "forms" }) },
      { val: "Suegro(a)", text: i18n.t("forms.options.suegro", { ns: "forms" }) },
      { val: "Hijo del Cónyuge que no sean suyos", text: i18n.t("forms.options.hijoDelConyugeQueNoSeanSuyos", { ns: "forms" }) },
      { val: "Abuelo(a) del cónyuge", text: i18n.t("forms.options.abueloDelConyuge", { ns: "forms" }) },
      { val: "Nieto(a) del cónyuge", text: i18n.t("forms.options.nietoDelConyuge", { ns: "forms" }) },
      { val: "Yerno", text: i18n.t("forms.options.yerno", { ns: "forms" }) },
      { val: "Nuera", text: i18n.t("forms.options.nuera", { ns: "forms" }) },
      { val: "Cuñado(a)", text: i18n.t("forms.options.cunado", { ns: "forms" }) }
    ],

    cargoOpt: [
      { val: "Director", text: i18n.t("forms.options.director", { ns: "forms" }) },
      { val: "Socio", text: i18n.t("forms.options.socio", { ns: "forms" }) },
      { val: "Accionista", text: i18n.t("forms.options.accionista", { ns: "forms" }) },
      { val: "Gerente", text: i18n.t("forms.options.gerente", { ns: "forms" }) },
      { val: "Ejecutivo Principal", text: i18n.t("forms.options.ejecutivoPrincipal", { ns: "forms" }) },
      { val: "Administrador", text: i18n.t("forms.options.administrador", { ns: "forms" }) },
      { val: "Asesor", text: i18n.t("forms.options.asesor", { ns: "forms" }) },
      { val: "Otro", text: i18n.t("forms.options.otro", { ns: "forms" }) }
    ],

    cargoInterlocking: [
      { val: "Ejecutivo Relevante", text: i18n.t("forms.options.ejecutivoRelevante", { ns: "forms" }) },
      { val: "Director", text: i18n.t("forms.options.director", { ns: "forms" }) }
    ],

    tipoDoc: [
      { val: "Chile-Rut", text: i18n.t("forms.options.chileRut", { ns: "forms" }) },
      { val: "Otros", text: i18n.t("forms.options.otros", { ns: "forms" }) }
    ],

    tipoPropiedad: [
      { val: "Directa", text: i18n.t("forms.options.tipoPropiedadDirecta", { ns: "forms" }) },
      { val: "Indirecta", text: i18n.t("forms.options.tipoPropiedadIndirecta", { ns: "forms" }) }
    ],

    tipoEmpresa: [
      { val: "Proveedor", text: i18n.t("forms.options.proveedor", { ns: "forms" }) },
      { val: "Contratista", text: i18n.t("forms.options.contratista", { ns: "forms" }) },
      { val: "Cliente", text: i18n.t("forms.options.cliente", { ns: "forms" }) }
    ],

    categoria: [
      { val: "PEP", text: i18n.t("forms.options.pep", { ns: "forms" }) },
      { val: "Funcionario Publico", text: i18n.t("forms.options.funcionarioPublico", { ns: "forms" }) }
    ],

    tipoInstitucion: [
      { val: "Fundación", text: i18n.t("forms.options.fundacion", { ns: "forms" }) },
      { val: "Corporación", text: i18n.t("forms.options.corporacion", { ns: "forms" }) },
      { val: "Institución de Beneficencia o Sin Fines de Lucro", text: i18n.t("forms.options.institucionDeBeneficenciaOSinFinesDeLucro", { ns: "forms" }) }
    ],

    giftType: [
      { val: "Regalos", text: i18n.t("forms.options.regalos", { ns: "forms" }) },
      { val: "Invitaciones", text: i18n.t("forms.options.invitaciones", { ns: "forms" }) },
      { val: "Beneficios no monetarios", text: i18n.t("forms.options.beneficiosNoMonetarios", { ns: "forms" }) }
    ],

    has: [
      { val: "Si", text: i18n.t("forms.options.si", { ns: "forms" }) },
      { val: "No", text: i18n.t("forms.options.no", { ns: "forms" }) },
    ],

    giftCategory: [
      {
        val: "Regalo de agradecimiento",
        text: i18n.t("forms.options.regaloDeAgradecimiento", { ns: "forms" }),
      },
      {
        val: "Felicitaciones por Cumpleaños",
        text: i18n.t("forms.options.felicitacionesPorCumpleanos", { ns: "forms" }),
      },
      {
        val: "Regalo promocional",
        text: i18n.t("forms.options.regaloPromocional", { ns: "forms" }),
      },
      {
        val: "Capacitación",
        text: i18n.t("forms.options.capacitacion", { ns: "forms" }),
      },
      {
        val: "Curso",
        text: i18n.t("forms.options.curso", { ns: "forms" }),
      },
      {
        val: "Seminario",
        text: i18n.t("forms.options.seminario", { ns: "forms" }),
      },
      {
        val: "Feria",
        text: i18n.t("forms.options.feria", { ns: "forms" }),
      },
      {
        val: "Evento de la industria",
        text: i18n.t("forms.options.eventoDeLaIndustria", { ns: "forms" }),
      },
      {
        val: "Otros",
        text: i18n.t("forms.options.otros", { ns: "forms" }),
      },
    ],

    radioBtnIds: [
      'hasOutdoorActivities',
      'hasInterlocking',
      'hasRelLabAnterior',
      'hasCompetencia',
      'hasParentesco',
      'hasPep',
      'hasRelacionProveedor',
      'hasFundaciones',
      'hasOtherConflicts',
      'hasOtherConflictsv2',
      'hasPemp',
      'hasPsoc'
    ]
  }
};
